module.exports = __webpack_public_path__ + "img/pic_TainanCity.fceecd9b.jpg";